import React, { useState } from "react";
import { FiArrowRight } from "react-icons/fi";
import Header from "../../component/header/header";
import { subjects, templateData } from "../Templates/demoData";
import { useNavigate } from "react-router-dom";
export default function CreateExam() {
  const [selectedSubject, setSelectedSubject] = useState<string | null>(null);
  const navigate = useNavigate();
  const handleToggle = (id: string) => {
    if (selectedSubject === id) {
      // Deselect if already selected
      setSelectedSubject(null);
    } else {
      // Select new subject
      setSelectedSubject(id);
    }
  };

  return (
    <div className="content exams">
      <Header
        pageTitle="Select Subject"
        buttonIcon={<FiArrowRight />}
        buttonText="Next"
        isActive={!!selectedSubject}
        para={
          <span>
            <p>
              Choose the subject for which you want to create the exam paper.
              This helps us tailor the topics and question s specifically to
              your selection.
            </p>
          </span>
        }
        onClick={() => {
          navigate(`/exams/create-exam/${selectedSubject}`);
        }}
      />

      <div className="flex w-full flex-col gap-4 mt-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 w-full">
          {templateData?.map((subject) => {
            const isSelected = selectedSubject === subject._id;
            const isDisabled = selectedSubject !== null && !isSelected;

            return (
              <div
                key={subject._id}
                className={`flex items-stretch rounded-md overflow-hidden transition-all duration-200 border ${
                  isSelected ? "border-red-500" : "border-gray-300"
                } opacity-${isDisabled ? "20" : "100"}`}
              >
                {!isSelected && (
                  <button
                    onClick={() => handleToggle(subject._id)}
                    className="bg-gray-300 text-red-500 px-3 py-2 text-2xl"
                    disabled={isDisabled}
                  >
                    +
                  </button>
                )}

                <div className="flex-1 bg-white px-4 py-2 flex items-center justify-between">
                  <span className="text-gray-800 font-medium">
                    {subject.subject}
                  </span>
                </div>

                {isSelected && (
                  <button
                    onClick={() => handleToggle(subject._id)}
                    className="bg-red-200 px-3 py-2 text-red-500 text-2xl"
                  >
                    −
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
